import ClientPortalRequests from './ClientPortalRequests';

export default ClientPortalRequests;
